module.exports = __webpack_public_path__ + "img/tally-4.259beebc.svg";